(() => {
  const sortSelects = document.querySelectorAll('[data-listing-sort]');
  if (!sortSelects.length) return;

  sortSelects.forEach((sortSelect) => {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      const value = sortSelect.value;

      if (value) {
        url.searchParams.set('sort_by', value);
      } else {
        url.searchParams.delete('sort_by');
      }

      if (url.pathname === '/search' && !url.searchParams.get('type')) {
        url.searchParams.set('type', 'product');
      }

      window.location.assign(url.toString());
    });
  });
})();